import styled from 'styled-components';
import { Box, Typography } from '@mui/material';

export const PriceFilterContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 400px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    min-width: 100%;
  }
`;

export const PriceFilterLabel = styled(Typography)`
  font-weight: 600;
  color: #333;
  font-size: 0.875rem;
  margin-bottom: 4px;
`;

export const CheckboxGroup = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: 16px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 8px;
  }
`;
